import { DashID, DashInfo } from './../../../types/drawing/dashed-lines';
import { AttributeStyle } from 'app/types/project-config';
import { RoutePart } from 'app/model/mapping/drawing/RouteFeature';
import { DataManagerService } from './../../services/data-manager.service';
import { PixoSpatialToGeoPoint, SpatialCoord } from 'app/model/mapping/Pixospatial';
import { RoutesService } from 'app/model/services/routes.service';
import { IDManager, ObjID } from './../../id-manager';
import { getGeom } from '@turf/invariant';
import { lineString, point as pointHelper, Geometry, GeometryObject } from '@turf/helpers';
import booleanIntersects from '@turf/boolean-intersects';
import * as turf from '@turf/turf';
import { v4 as uuid } from 'uuid';
import { D3DragEvent, drag } from 'd3-drag';
import * as d3 from 'd3';
import { PixoSpatial, PixoSpatialCoord } from '../Pixospatial';
import { EventEmitter, inject } from '@angular/core';
import { Dict } from 'app/types/decorable';
import { Handler } from 'app/types/handlers';
import { nearestPointOnLine } from '@turf/turf';
import { AddPointRoute, RemovePointRoute } from './RouteFeature';
import { getDistance } from 'geodesy-js';
import { Length } from 'unitsnet-js';
export interface IFeatureContext {
  roiGroup?: any;
  polyLabels?: any;
  segmentLabels?: any;
  pointLabels?: any;
  polygonGroup?: any;
  segmentGroup?: any;
  pointGroup?: any;
  drawRect?: any;
  idManager?: IDManager;
  container?: any;
  isOn?: boolean;
  updateHandler(feature: Feature): void;

}

export interface IFeature {
  id?: number;
  readonly type: string;
  Remove(): void;
  ToGeoJSONGeom(): GeometryObject | false;
  FromGeoJSONGeom(geom: Geometry): void;
  GetSelectedInfo(): any;
  AddVertex(ptInfo: any, xProp?: string, yProp?: string): void;

}
export type DrawingFeatureType = 'line' | 'point' | 'poly' | 'segment';
export type IDFactory = (type: DrawingFeatureType, feature: IFeature) => void;



export class Feature implements IFeature {
  get type(): string {
    return '';
  }
  protected lookup: any = {};
  protected lastSelection?: string;
  protected context?: IFeatureContext;
  protected localContext: IFeatureContext = { updateHandler: (feature: Feature) => { } };
  protected groups: Array<any> = [];
  protected vertices = 0;
  protected spatialContext?: PixoSpatial;
  protected dataMgr?: DataManagerService = DataManagerService.instance;
  public segments?: Array<any>;
  public points: Array<any> = [];

  public get id(): number | undefined {
    return this.privateId;
  }
  public set id(val: number | undefined) {
    this.privateId = val;
    if (!!val) {
      this.lookup[val] = this;
    }
  }
  public get hasVertices(): boolean {
    return this.points.length > 0;
  }

  public get vertexSelected(): boolean {
    if (!this.lookup) {
      return false;
    }
    if (!this.lastSelection) {
      return false;
    }
    if (!this.lookup[this.lastSelection]) {
      return false;
    }
    return (this.lookup[this.lastSelection].type === 'point');
  }


  protected privateId?: number;
  public static idFactory?: IDFactory;
  public selectionChange = new EventEmitter<Dict>();
  public geometryChange = new EventEmitter<Dict>();
  public get geometryCount(): number {
    let length = 0;
    if (!!this.segments && this.segments.length > 0) {
      length += this.segments.length;
    }
    length += this.points.length;
    return length;
  }
  constructor(context: IFeatureContext, spatialContext?: PixoSpatial) {
    this.context = context;
    this.spatialContext = spatialContext;
    this.points = [];
  }
  public static SetIDFactory(factory: IDFactory) {
    Feature.idFactory = factory;
  }
  SelectFeature() {
    if (!this.lastSelection) if (!this.lastSelection) return;

    if (!!this.lookup[this.lastSelection]) {
      this.lookup[this.lastSelection].ui.classed('selected', true);
      if (this.lookup[this.lastSelection].label) {
        this.lookup[this.lastSelection].label.classed('selected', false);
      }
    }
    this.lastSelection = this.lastSelection;
  }
  DeselectFeature(featureId?: ObjID) {
    /*for (const group of this.groups) {
      group.classed('selected', false);
    }*/
    const id = (!!featureId) ? featureId : this.lastSelection;

    if (!id) return;
    if (!!this.lookup[id]) {
      this.lookup[id].ui.classed('selected', false);
      if (this.lookup[id].label) {
        this.lookup[id].label.classed('selected', false);
      }
      this.lookup[id].updateUI();
    }
    this.lastSelection = undefined;
    this.ContextChanged();
  }
  Select(targetId: string, _self: ObjID, routeSelect: true | false | 'auto' = true): void {
    const feature = this.dataMgr?.GetProject()?.idRegistry.Get(targetId as ObjID);
    if (!!this.lastSelection && (this.lastSelection !== targetId)) {
      //this.DeselectFeature();

      /*if (this.lookup.hasOwnProperty(this.lastSelection) !== false) {
        const lastSelect = this.lookup[this.lastSelection].ui;
        lastSelect.classed('selected', false);
      }*/


    }
    if (!feature) return;
    this.lastSelection = targetId;
    this.selectionChange.emit({ selectedId: targetId });
    //if (this.lookup[this.lastSelection]) {
    feature.ui.classed('selected', true);
    if (feature.label) {
      feature.label.classed('selected', true);
    }
    const type = (feature.type === 'point') ? 'vertex-selected' : 'segment-selected';
    RoutesService.Notify(type, Number(this.id!), Number(this.lastSelection));
    //}

  }
  GenerateID(type: DrawingFeatureType, feature: IFeature): void {
    if (!!Feature.idFactory && !!type) {
      return Feature.idFactory(type, feature);
    }
  }

  /* UpdateSharedPoints(pt: any) {
     if (pt.sharedPts) {
       for (const sharedPt of pt.sharedPts) {
         if (!sharedPt.ui) continue;
         sharedPt.x = pt.x;
         sharedPt.y = pt.y;
         sharedPt.updateUI();
         if (this.spatialContext !== null) {
           (sharedPt.coord as PixoSpatialCoord).UpdatePixo(sharedPt.x, sharedPt.y);
         }
         pt.ui.classed('shared', pt.routes.length >= 1);
         pt.updateSegs();
       }
     }

   }
   */
  private dragOffset = { x: 0, y: 0 };
  HandleVertexDrag(event: D3DragEvent<SVGElement, any, any>, final: boolean = false): any {
    if (!this.lastSelection) return;
    const pt = this.lookup[this.lastSelection];

    if (!pt.ui) return;

    // const dx = event.x - event.subject.x + 4;
    // const dy = event.y - event.subject.y + 4;
    let dx = Number(event.sourceEvent.toElement.attributes.dx?.value.replace('px', ''));
    let dy = Number(event.sourceEvent.toElement.attributes.dy?.value.replace('px', ''));
    if (isNaN(dx)) dx = 0;
    if (isNaN(dy)) dy = 0;
    const newX: number = event.x - dx + this.dragOffset.x;
    const newY: number = event.y - dy + this.dragOffset.y;
    if (isNaN(newX)) {
      return;
    }
    if (isNaN(newY)) {
      return;
    }
    pt.x = newX;
    pt.y = newY;

    if (this.spatialContext !== null) {
      (pt.coord as PixoSpatialCoord)?.UpdatePixo(newX, newY);
    }
    pt.updateUI(false);

    const ptId = Number(pt.ui.attr('data-guid'));
    if (ptId === undefined) {
      return;
    }

    // pt.updateSegs();
    // this.UpdateSharedPoints(pt);
    /*for (const seg of pt.segments) {
      if (seg.from.id === ptId) {
        seg.from.x = newX;
        seg.from.y = newY;
        seg.updateUI();
      }
      if (seg.to.id === ptId) {
        seg.to.x = newX;
        seg.to.y = newY;
        seg.updateUI();

      }
    }*/
    return pt;
  }
  HandleEndVertexDrag(event: D3DragEvent<SVGElement, any, any>) {
    if (event.dx + event.dy === 0) {
      this.UpdateContextHandler();
      return;
    }
    this.HandleVertexDrag(event, true);
    const targetId = Number((event.sourceEvent.target as HTMLElement).attributes?.getNamedItem('data-guid')?.value);
    // this.UpdateSharedPoints(this.lookup[this.lastSelection!]);
    const feature = this.dataMgr?.GetProject()?.idRegistry.Get(targetId);
    if (feature?.ui?.ClickHandler) {
      // feature.ui.ClickHandler();
    }
    // if (feature?.updateUI) feature.updateUI();
    // this.Select('' + targetId, this.id!);

    this.UpdateContextHandler();
  }
  MakeFontVertex(points: Array<any>, ptInfo: any, xProp: string = 'x', yProp: string = 'x', zProp: string = 'z'): any {
    if (!this.spatialContext) throw new Error('attempting to call MakeVertex without first setting a spatial context')
    const ptGroup = this.context?.pointGroup;
    const ptLabelGroup = this.context?.pointLabels;
    const pt: any = ptInfo.id ? ptInfo : {};
    const wasExisting = (!!ptInfo.type);
    if (!wasExisting) {
      pt.routes = [this.id];
      pt.type = 'point';
      pt.x = ptInfo[xProp];
      pt.y = ptInfo[yProp];
      pt.updateUI = (updateStyle: boolean = false) => {
        if ((!pt.x) || (!pt.y)) return;
        const oldX = pt.ui.attr('x');
        const oldY = pt.ui.attr('y');
        const isVis = !pt.ui.classed('not-viz');
        const selected = pt.ui.classed('selected');

        pt.ui.attr('x', pt.x);
        pt.ui.attr('y', pt.y);
        pt.label.attr('x', pt.x);
        pt.label.attr('y', pt.y);
        pt.label.classed('not-viz', !isVis);
        if (!!pt.partId) {
          const part = this.dataMgr?.GetProject()?.idRegistry.Get(pt.partId) as RoutePart;
          if (!!part?.data) {
            pt.label.text(part.data.pointName);
          }
          pt.ui.attr('data-guid', pt.id);
          if (updateStyle) {
            const fill = !!part.style?.color ? part.style.color : '#000';
            pt.ui.attr('fill', fill);
            let size = part.style?.size;
            let fontSizeRem = 0;
            let dyBase = 0;
            pt.ui.classed('half', false);
            pt.ui.classed('normal', false);
            pt.ui.classed('double', false);
            if (!size) { size = 'normal'; }

            if (!!part.style?.symbol) {

              pt.ui.attr('class', part.style.symbol.css);

              const char = window.getComputedStyle(pt.ui.node(), ':before').content.charCodeAt(1).toString(16);
              pt.ui.attr('class', 'text-marker-icon ' + (part.style.symbol.solid ? 'fas' : 'far'));
              pt.ui.text(String.fromCharCode(Number('0x' + char)));
              pt.ui.classed(size, true);
              fontSizeRem = Number(window.getComputedStyle(pt.ui.node()).fontSize.replace('px', '')) / 16;
              dyBase = fontSizeRem * 0.357;
              pt.ui.attr('dx', part.style.symbol.offsetX === undefined ? '0rem' : (part.style.symbol.offsetX * 0.357) + 'px');
              const dy = part.style.symbol.offsetY === undefined ? dyBase + 'rem' : (dyBase * 16) - (part.style.symbol.offsetY / 2) + 'px';
              pt.ui.attr('dy', dy);
              pt.ui.classed('not-viz', !isVis);
            }
          }
        }
        for (const seg of pt.segments) {
          seg.updateUI();
        }
        // pt.ui.text('Hello World');
        this.PointUpdated(pt, oldX, oldY);
        pt.ui.classed('selected', selected);

      };
      if (this.spatialContext !== null) {
        const coord = this.spatialContext.PixoPt(pt);

        pt.coord = this.spatialContext.PixoSpatialCoord(coord);
        pt.coord.PostConvert = () => {
          pt.x = pt.coord.pixo.x;
          pt.y = pt.coord.pixo.y;
          pt.updateUI();
        };
      }
      this.GenerateID('point', pt as IFeature);

      pt.featureId = this.id;

      if (zProp === null) {
        pt.z = ptInfo[zProp];
      }
      pt.index = points.length;
      pt.segments = [];
      pt.ui = ptGroup.append('text');
      pt.label = ptLabelGroup.append('text');
      pt.label.attr('class', 'pt-marker-label');
      pt.label.attr('x', function (d: any) { return pt.x; });
      pt.label.attr('y', function (d: any) { return pt.y; });
      pt.label.attr('dx', '0px');
      pt.label.attr('dy', '-1.25rem');
      pt.label.attr('text-anchor', 'middle');
      pt.label.text('');
      // pt.ui.attr('x', function (d: any) { return pt.x; });
      // pt.ui.attr('y', function (d: any) { return pt.y; });
      // pt.ui.attr('dx', '0px');
      // pt.ui.attr('dy', '.25rem');
      // pt.ui.text(ptInfo.label);
      pt.ui.attr('text-anchor', 'middle');
      // pt.ui.attr('class', 'text-marker-icon fas');
      // pt.ui.text(String.fromCharCode(Number('0xf0ad')));
      pt.ui.attr('data-guid', pt.id);
      // pt.ui.style('fill', '#f00');
      pt.ui.style('fill-opacity', 1);
      pt.ui.call(d3.drag()
        .on('start', (event: D3DragEvent<SVGElement, any, any>) => {
          if (this.dataMgr?.GetSelected()?.feature !== pt.id) {
            event.sourceEvent.preventDefault();
            pt.dragged = false;
            return;
          }
          pt.dragged = true;

          const ptId = d3.select(event.sourceEvent.srcElement).attr('data-guid');
          const eventX = Number(event.sourceEvent.toElement.attributes.x.value)
          const eventY = Number(event.sourceEvent.toElement.attributes.x.value);
          this.dragOffset.x = event.x - Number(event.sourceEvent.toElement.attributes.x.value);
          this.dragOffset.y = Number(event.sourceEvent.toElement.attributes.y.value) - event.y;
          const mode = event.sourceEvent.shiftKey === true ? false : 'auto';
          // this.Select(ptId, this.id!, mode);
        })
        .on('end', (event: D3DragEvent<SVGElement, any, any>) => {
          if (pt.dragged) {
            // if (event.sourceEvent.defaultPrevented) return;
            this.HandleEndVertexDrag(event);

          }
        })
        .on('drag', (event: D3DragEvent<SVGElement, any, any>) => {
          if (pt.dragged) {
            // if (event.sourceEvent.defaultPrevented) return;
            this.HandleVertexDrag(event);
          } })
      );
      this.lookup[pt.id] = pt;
      pt.ui.on('mousedown', () => {
        this.Select(pt.id, this.id!);
      });
      pt.ui.ClickHandler = (e: any) => {
        if (e.defaultPrevented) return; // dragged
        const mode = e.shiftKey === true ? false : 'auto';
        this.Select(pt.id, this.id!, mode);
        //window.requestAnimationFrame(() => {
        pt.updateUI();
        //})
      }
      pt.ui.on('click', (e: any) => {
        pt.ui.ClickHandler(e);
      });
      pt.remove = () => {
        pt.ui.on('.drag', null);

        pt.ui.on('mousedown', null);
        pt.ui.on('click', null);
        pt.ui.remove();
        pt.unshare(this.id);
        delete this.lookup[pt.id];
        const ptI = points.indexOf(pt);
        if (ptI > -1) {
          points.splice(ptI, 1);
        }
        this.UpdateContextHandler();
        return pt;
      };
      pt.removeSegment = (seg: any) => {
        const segI = pt.segments.indexOf(seg);
        if (segI > -1) {
          pt.segments.splice(segI, 1);
        }
      };
      pt.addSegment = (seg: any) => {
        if (pt.segments.indexOf(seg) < 0) {
          pt.segments.push(seg);
        }
      };
      pt.updateSegs = () => {
        for (const ptSeg of pt.segments) {
          ptSeg.updateUI();
        }

      };
      // pt.ui.classed('shared', wasExisting);
      pt.share = (routeId: ObjID) => {
        AddPointRoute(routeId, pt);
      }
      const me = this;
      pt.unshare = (routeId: ObjID) => {
        const project = DataManagerService.instance?.GetProject();
        RemovePointRoute(routeId, pt);
      }
      // pt.updateUI();
    }
    if (!this.lookup[pt.id]) {
      this.lookup[pt.id] = pt;
    }
    points.push(pt);
    this.vertices = points.length;

    this.UpdateContextHandler();
    return pt;

  }
  MakeVertex(points: Array<any>, ptInfo: any, xProp: string = 'x', yProp: string = 'y', zProp: string = 'z'): any {
    if (xProp === 'x') {
      return this.MakeFontVertex(points, ptInfo, xProp, yProp, zProp);
    }
    const ptGroup = this.context?.pointGroup;
    if (!this.spatialContext) throw new Error('attempting to call MakeVertex without first setting a spatial context')
    const pt: any = ptInfo.id ? ptInfo : {};
    const wasExisting = (!!ptInfo.type);
    if (!wasExisting) {
      // this.lookup[pt.id] = pt;

      pt.routes = [this.id];
      pt.type = 'point';
      pt.x = ptInfo[xProp];
      pt.y = ptInfo[yProp];

      pt.updateUI = () => {
        const oldX = pt.ui.attr('cx');
        const oldY = pt.ui.attr('cy');

        pt.ui.attr('cx', pt.x);
        pt.ui.attr('cy', pt.y);
        for (const seg of pt.segments) {
          seg.updateUI();
        }

        this.PointUpdated(pt, oldX, oldY);
      };

      if (this.spatialContext !== null) {
        const coord = this.spatialContext.PixoPt(pt);

        pt.coord = this.spatialContext.PixoSpatialCoord(coord);
        pt.coord.PostConvert = () => {
          pt.x = pt.coord.pixo.x;
          pt.y = pt.coord.pixo.y;
          pt.updateUI();
        };
      }
      this.GenerateID('point', pt as IFeature);
      pt.featureId = this.id;

      if (zProp === null) {
        pt.z = ptInfo[zProp];
      }
      pt.index = points.length;
      pt.segments = [];
      pt.ui = ptGroup.append('circle');
      pt.ui.attr('cx', function (d: any) { return pt.x; });
      pt.ui.attr('cy', function (d: any) { return pt.y; });
      pt.ui.attr('r', 8);

      pt.ui.classed('point', true);
      pt.ui.attr('data-guid', pt.id);
      pt.ui.call(d3.drag()
        .on('start', (event: D3DragEvent<SVGElement, any, any>) => {
          const ptId = d3.select(event.sourceEvent.srcElement).attr('data-guid');
          const mode = event.sourceEvent.shiftKey === true ? false : 'auto';
          this.Select(ptId, this.id!, 'auto');
        })
        .on('end', (event: D3DragEvent<SVGElement, any, any>) => { this.HandleEndVertexDrag(event); })
        .on('drag', (event: D3DragEvent<SVGElement, any, any>) => { this.HandleVertexDrag(event); })
      );
      this.lookup[pt.id] = pt;
      pt.ui.on('mousedown', () => {
        // this.Select(pt.id, this.id!);
      });
      pt.ui.on('mouseup', (e: any) => {
        // pt.updateUI();
        const mode = e.sourceEvent.shiftKey === true ? false : 'auto';
        this.Select(pt.id, this.id!, mode);
      })
      pt.remove = () => {
        pt.ui.on('.drag', null);
        pt.ui.on('mousedown', null);
        pt.ui.remove();
        delete this.lookup[pt.id];
        const ptI = points.indexOf(pt);
        if (ptI > -1) {
          points.splice(ptI, 1);
        }
        this.UpdateContextHandler();
        return pt;
      };
      pt.removeSegment = (seg: any) => {
        const segI = pt.segments.indexOf(seg);
        if (segI > -1) {
          pt.segments.splice(segI, 1);
        }
      };
      pt.addSegment = (seg: any) => {
        if (pt.segments.indexOf(seg) < 0) {
          pt.segments.push(seg);
        }
      };
      pt.updateSegs = () => {
        for (const ptSeg of pt.segments) {
          ptSeg.updateUI();
        }
      };
      // pt.ui.classed('shared', wasExisting);
      pt.share = (routeId: ObjID) => {
        AddPointRoute(routeId, pt);
      }
      const me = this;
      pt.unshare = (routeId: ObjID) => {
        const project = DataManagerService.instance?.GetProject();
        RemovePointRoute(routeId, pt);
      }
    }
    if (!this.lookup[pt.id]) {
      this.lookup[pt.id] = pt;
    }
    points.push(pt);
    this.vertices = points.length;

    this.UpdateContextHandler();
    return pt;
  }
  MakeSegment(points: Array<any>, segments: Array<any>, fromPt = null, toPt = null, ending: string = 'end'): any {
    const segmentGroup = this.context?.segmentGroup;
    const segLabelGroup = this.context?.segmentLabels;
    if ((!!fromPt && !!toPt) || (points.length > 1)) {
      if (fromPt === null) {
        fromPt = points[points.length - 2];
      }
      if (toPt === null) {
        toPt = points[points.length - 1];
      }
      const seg: any = {};
      seg.routes = [this.id];
      seg.type = 'segment';
      seg.featureId = this.id;
      this.GenerateID('segment', seg);
      seg.from = fromPt;
      seg.from.segments.push(seg);
      seg.to = toPt;
      seg.to.segments.push(seg);
      if (ending === 'start') {
        seg.ui = segmentGroup.insert('line', ':first-child');
      } else {
        seg.ui = segmentGroup.append('line');
      }
      seg.ui.attr('id', 'path' + seg.id);
      seg.ui.classed('seg-' + seg.featureId, true);
      console.log('segment ui', seg.ui);
      seg.label = segLabelGroup.append('text');

      seg.split = (asVertex: boolean = true): void | { x: number, y: number } => {
        const xDelta = Math.abs(seg.deltaXpx);
        const yDelta = Math.abs(seg.deltaYpx);
        const midX = Math.min(seg.from.x, seg.to.x) + (xDelta / 2.0);
        const midY = Math.min(seg.from.y, seg.to.y) + (yDelta / 2.0);

        return asVertex ? seg.AddVertex(midX, midY) : { x: midX, y: midY };
      }

      seg.deltaXpx = Math.abs((seg.to.x - seg.from.x));
      seg.deltaYpx = Math.abs((seg.to.y - seg.from.y));
      seg.pxDistance = Math.sqrt(Math.pow(seg.deltaXpx, 2) + Math.pow(seg.deltaYpx, 2));
      seg.midPt = seg.split(false);
      seg.label.attr('class', 'seg-marker-label');
      seg.label.attr('x', seg.midPt.x);
      seg.label.attr('y', seg.midPt.y);
      seg.label.attr('dy', '-.25rem');

      // seg.label.attr('dx', '0px');
      // seg.label.attr('dy', '-1.25rem');
      seg.label.attr('text-anchor', 'middle');
      seg.share = (routeId: ObjID) => {
        if (seg.routes.indexOf(routeId) < 0) {
          seg.routes.push(routeId);
        }
      }
      seg.unshare = (routeId: ObjID) => {
        seg.routes.splice(seg.routes.indexOf(routeId), 1)
      }
      seg.updateUI = (updateStyle: boolean = false) => {
        if ((!!seg.from) && (!!seg.to)) {
          seg.deltaXpx = ((seg.to.x - seg.from.x));
          seg.deltaYpx = ((seg.to.y - seg.from.y));
          seg.pxDistance = Math.sqrt(Math.pow(seg.deltaXpx, 2) + Math.pow(seg.deltaYpx, 2));
          seg.midPt = seg.split(false);
          const info: any = {
            x1: seg.from.x,
            y1: seg.from.y,
            x2: seg.to.x,
            y2: seg.to.y,
            'data-guid': seg.id
          };
          seg.length = Number((getDistance(
            PixoSpatialToGeoPoint(seg.from.coord),
            PixoSpatialToGeoPoint(seg.to.coord)
          ) as Length).Feet.toFixed(0));
          for (const key in info) {
            if (info.hasOwnProperty(key)) {
              seg.ui.attr(key, info[key]);
            }
          }

          seg.ui.classed('line', true);
          seg.label.attr('x', seg.midPt.x);
          seg.label.attr('y', seg.midPt.y);
          if (updateStyle === true) {
            if (!!seg.style) {
              seg.ui.attr('stroke', seg.style?.color ? seg.style.color : '#000000');
              switch (seg.style.thickness) {
                case 'thick':
                  seg.ui.attr('stroke-width', '4px');
                  break;
                case 'medium':
                  seg.ui.attr('stroke-width', '3px');
                  break;
                case 'thin':
                  seg.ui.attr('stroke-width', '1px');
                  break;
              }
              const pattern = DashInfo.Get(seg.style.pattern);
              if (pattern) {
                seg.ui.attr('stroke-dasharray', DashInfo.GetDashArray(pattern, seg.style.thickness));
                seg.ui.attr('stroke-dashoffset', DashInfo.GetDashOffset(pattern, seg.style.thickness))
              } else {
                seg.ui.attr('stroke-dasharray', '');
                seg.ui.attr('stroke-dashoffset', '');
              }
            }
          }
          const angle = Math.atan2(seg.deltaYpx, seg.deltaXpx) * 180 / Math.PI;
          let adjAngle = (seg.deltaXpx > 0) ? angle : 180 + angle;
          const transform = `rotate(${adjAngle.toFixed(6)},${seg.midPt.x.toFixed(6)},${seg.midPt.y.toFixed(6)})`;

          if (!!seg.partId) {
            const part = this.dataMgr?.GetProject()?.idRegistry.Get(seg.partId);
            if (!!part) {
              seg.label.text(part.data.segmentName);
            }
          }
          // seg.label.attr('transform',`rotate(0,${seg.midPt.x},${seg.midPt.y}`);

          if (Math.abs(seg.pxDistance) < seg.label.node().textLength.baseVal.value + 16) {
            seg.label.text('');
          }

          seg.label.attr('transform', transform);

        }
      };
      seg.updateUI();
      seg.ui.on('mouseover', (e: MouseEvent) => {

      });
      seg.ui.on('dblclick', (e: MouseEvent) => {
        e.preventDefault();
      });
      seg.ui.on('click', (e: any) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (!this.context) return;
        if (this.lastSelection === seg.id) {
          const mouse = d3.pointer(e, this.context.container);
          if (this.dataMgr?.GetProject()?.drawPane?.isOn === false) {
            return;
          }
          seg.AddVertex(mouse[0], mouse[1]);
        } else {
          const mode = e.shiftKey === true ? false : 'auto';
          this.Select(seg.id, this.id!, mode);
        }
      });
      if (ending === 'start') {
        const firstSeg = segments[0];
        firstSeg.prevSegment = seg;
        seg.nextSegment = firstSeg;
        seg.prevSegment = null;
        segments.unshift(seg);
        this.UpdateContextHandler();
      } else {
        seg.prevSegment = (segments.length > 0) ? segments[segments.length - 1] : null;
        if (seg.prevSegment !== null) {
          seg.prevSegment.nextSegment = seg;
        }
        seg.nextSegment = null;
        segments.push(seg);
        this.UpdateContextHandler();
      }



      this.lookup[seg.id] = seg;
      seg.AddExistingVertex = (pt: any) => {
        const clickSeg = seg;
        const oldNextSeg = clickSeg.nextSegment;
        const newSeg = this.MakeSegment(points, segments, pt, clickSeg.to);

        const segI = segments.indexOf(clickSeg);
        if (segI > -1) {
          segments.splice(segI + 1, 0, segments.pop());
          segments[segments.length - 1].nextSegment = null;
        }
        if (!!oldNextSeg) {
          // remove the curent segment from the current segment to-point's segment list
          clickSeg.to.removeSegment(clickSeg);
          // add the new segment as the current segment's to-point's segment list.
          clickSeg.to.addSegment(newSeg);
          // old next seg prev is current segment, point it to newSeg instead.
          oldNextSeg.prevSegment = newSeg;
          oldNextSeg.updateUI();
          // the old nextSeg shoudl be the new seg's next seg.
          newSeg.nextSegment = oldNextSeg;
          newSeg.updateUI();

        }
        // new segment's to point should be current segment's to point.
        newSeg.to = clickSeg.to;
        // make current segment's next segment the new segment.
        clickSeg.nextSegment = newSeg;
        // the to-point for the current segment should now be the new point.
        clickSeg.to = pt;
        // the new point will need a reference to the current segment.
        clickSeg.to.addSegment(clickSeg);
        clickSeg.updateUI();
        // remove the pt from this route's point list.
        let ptI; // = points.indexOf(pt);
        /*if (ptI > -1) {
          points.splice(ptI, 1);
        }
        */
        ptI = points.indexOf(seg.from);
        newSeg.prevSegment = clickSeg;

        pt.addSegment(newSeg);
        /*if (ptI > -1) {
          points.splice(ptI + 1, 0, pt);
        } else {
          points.push(pt);

        }*/
        if (ptI === -1) {
          points.push(pt);
        }
        this.VertexAddedTo(pt, clickSeg);

        this.Select(pt.id, this.id!);
        return pt;

      }
      seg.AddVertex = (x: number, y: number) => {
        const pt = this.MakeVertex(points, { x: (x), y: (y) });
        this.Select(pt.id, this.id!);
        return seg.AddExistingVertex(pt);
      }
      seg.AddVertexNearest = (x: number, y: number) => {
        const pixo = this.spatialContext?.PixoPt({ x: (x), y: (y) });
        const geoPt = pixo!.convert();
        const fromGeom = seg.from.coord.spatial;
        const toGeom = seg.to.coord.spatial;
        const tLine = lineString([[fromGeom.lng, fromGeom.lat], [toGeom.lng, toGeom.lat]]);
        const tPoint = pointHelper([geoPt.lng, geoPt.lat]);
        const nearest = nearestPointOnLine(tLine, tPoint, { units: 'meters' });
        const nC = nearest.geometry.coordinates;
        const nSpatial: any = this.spatialContext?.SpatialCoord({ lng: nC[0], lat: nC[1] });
        const nPt = nSpatial.convert();
        const pt = seg.AddVertex(nPt.x, nPt.y);
        return pt;
      }
      seg.removed = false;
      seg.remove = () => {
        seg.removed = true;
        seg.ui.on('click', null);
        seg.ui.remove();
        if (seg.nextSegment !== null) {
          seg.nextSegment.prevSegment = seg.prevSegment;
        }
        if (seg.prevSegment !== null) {
          seg.prevSegment.nextSegment = seg.nextSegment;
        }
        if (seg.from !== null) {
          seg.from.removeSegment(seg);
        }
        if (seg.to !== null) {
          seg.to.removeSegment(seg);
        }
        delete this.lookup[seg.id];
        if (!!seg.nextSegment) {
          seg.nextSegment.updateUI();
        }
        if (!!seg.prevSegment) {
          seg.prevSegment.updateUI();
        }
        const segi = segments.indexOf(seg);
        if (segi > -1) {
          segments.splice(segi, 1);
        }
        return seg;
      };
      seg.updateUI();
      return seg;
    }

  }
  GetCoordinates(points: Array<any>): Array<any> {
    const coords: Array<any> = [];
    for (const vertex of points) {
      coords.push([vertex.x, vertex.y]);
    }
    return coords;
  }
  DeleteGeometry() {
    for (let i = this.points.length - 1; i >= 0; i--) {
      const point = this.points[i];
      this.Select(this.points[i], this.id as number);
      this.RemoveSelected();

    }

  }
  RemoveSelected() {
    if (!this.lastSelection) {
      return;
    }

    const item = this.lookup[this.lastSelection];
    item.unshare(this.id);

    this.FeatureRemoved(item);
    let keepPtUI = false;
    if (item.type === 'point') {
      this.points.splice(item.id, 1);
      if (item.routes.length !== 0) {
        keepPtUI = true;
      }
    }
    if (item.type === 'segment') {
      const points = [item.from, item.to];
      this.Select(points[1].id, this.id!);
      this.RemoveSelected();
      this.Select(points[0].id, this.id!);
      this.RemoveSelected();
      this.geometryChange.emit(this);
      return;
    }
    this.lastSelection = undefined;
    for (const seg of item.segments) {
      if (seg.removed === true) {
        continue;
      }
      if (seg.featureId !== this.id) continue;
      if (seg.to === item) {

        if (seg.nextSegment !== null) {
          seg.to = seg.nextSegment.to;
          seg.to.addSegment(seg);
          seg.updateUI();
          this.FeatureRemoved(seg.nextSegment);
          seg.nextSegment.remove();

        } else {
          seg.to = null;
          this.FeatureRemoved(seg.from);
          seg.from.removeSegment(seg);
          seg.remove();
          this.FeatureRemoved(seg.from);

        }
        this.Select(seg.from.id, this.id!);


      } else if (seg.from === item) {
        if (!!seg.prevSegment) {
          if (seg.prevSegment.removed === false) {
            if (item.segments.indexOf(seg.prevSegment) > -1) {
              continue;
            }
          }
          if (seg.prevSegment !== null) {
            seg.prevSegment.to = seg.to;
            seg.to.addSegment(seg.prevSegment);
            seg.prevSegment.updateUI();
          }
        }
        seg.to.removeSegment(seg);
        this.FeatureRemoved(seg);
        seg.remove();

        this.Select(seg.to.id, this.id!);
      }
    }
    item.ui.classed('selected', false);

    if (keepPtUI === false) {
      item.remove();
    }
    this.PointRemoved(item);
  }
  PointRemoved(pt: any) {
    // extend Feature and override me as needed;
    this.UpdateContextHandler();
  }
  PointUpdated(pt: any, oldX: number, oldY: number) {
    // extend Feature and override me as needed;
    this.UpdateContextHandler();
  }
  VertexAddedTo(pt: any, seg: any) {
    this.UpdateContextHandler();
    this.Select(pt.id, this.id!);
  }
  RemovePoints(points: Array<any>) {
    for (const pt of points) {
      pt.remove();
    }

    this.lookup = {};
    this.lastSelection = undefined;
    delete this.context;
    for (const group of this.groups) {
      group.remove();
    }
    this.groups = [];
    this.UpdateContextHandler()

  }
  ContextChanged() {
    if (this.spatialContext === null) { return; }
    for (const pt of this.points) {
      const x = pt.coord.x;
      const y = pt.coord.y;
      (pt.coord as PixoSpatialCoord).UpdateSpatial(pt.coord.spatial.lng, pt.coord.spatial.lat);
      pt.updateUI(true);

    }
    this.UpdateContextHandler();
    // this.context.updateHandler(this);

  }
  public GetSelectedInfo(): any {
    if (!this.lastSelection) {
      return null;
    }
    if (!!this.lookup[this.lastSelection]) {
      return this.lookup[this.lastSelection];
    }
    return null;
  }
  public GetGeometry(): Array<any> {
    const geometry = [];
    const segments = 'segments';
    let ctr = -1;
    for (const point of this.points) {
      ctr += 1;
      geometry.push(point);
      if (!!this.segments?.length && this.segments.length > ctr) {
        geometry.push(this.segments[ctr]);
      }

    }
    return geometry;
  }
  public IsSelected(geomId: string): boolean {
    return (this.lastSelection === geomId);
  }
  public Remove(): void {
    // do nothing
  }
  UpdateContextHandler() {
    if (this.context) {
      this.geometryChange.emit(this);
      this.context.updateHandler(this);
    }
  }
  GetSelectedId() {
    return this.lastSelection;
  }

  ToGeoJSONGeom(): GeometryObject | false {
    return false; // override me;
  }
  FromGeoJSONGeom(_1geom: Geometry): void {
    return;
  }
  AddVertex(ptInfo: any, xProp?: string, yProp?: string): void {
    // do nothing; override me
  }
  FeatureIntersects(feature1: any, feature2: any) {
    const permutation = feature1.type + '-' + feature2.type;
    let pt1;
    let pt2;
    let seg1;
    let seg2;

    switch (permutation) {
      case 'point-point':
        pt1 = pointHelper([feature1.coord.spatial.lng, feature1.coord.spatial.lat]);
        pt2 = pointHelper([feature2.coord.spatial.lng, feature2.coord.spatial.lat]);
        return turf.booleanEqual(pt1, pt2);
      case 'point-segment':
        pt1 = pointHelper([feature1.coord.spatial.lng, feature1.coord.spatial.lat]);
        seg1 = lineString([
          [feature2.from.coord.spatial.lng, feature2.from.coord.spatial.lat],
          [feature2.to.coord.spatial.lng, feature2.to.coord.spatial.lat]
        ]);
        return turf.booleanPointOnLine(pt1, seg1);
      case 'segment-point':
        pt1 = pointHelper([feature2.coord.spatial.lng, feature2.coord.spatial.lat]);
        seg1 = lineString([
          [feature1.from.coord.spatial.lng, feature1.from.coord.spatial.lat],
          [feature1.to.coord.spatial.lng, feature1.to.coord.spatial.lat]
        ]);
        return turf.booleanPointOnLine(pt1, seg1);
      case 'segment-segment':
        seg1 = lineString([
          [feature1.from.coord.spatial.lng, feature1.from.coord.spatial.lat],
          [feature1.to.coord.spatial.lng, feature1.to.coord.spatial.lat]
        ]);

        seg2 = lineString([
          [feature2.from.coord.spatial.lng, feature2.from.coord.spatial.lat],
          [feature2.to.coord.spatial.lng, feature2.to.coord.spatial.lat]
        ]);
        return booleanIntersects(seg1, seg2);
    }
    return false;
  }
  SegmentIntersection(segment1: any, segment2: any): undefined | PixoSpatialCoord {

    const seg1 = lineString([
      [segment1.from.coord.spatial.lng, segment1.from.coord.spatial.lat],
      [segment1.to.coord.spatial.lng, segment1.to.coord.spatial.lat]
    ]);

    const seg2 = lineString([
      [segment2.from.coord.spatial.lng, segment2.from.coord.spatial.lat],
      [segment2.to.coord.spatial.lng, segment2.to.coord.spatial.lat]
    ]);
    if (!booleanIntersects(seg1, seg2)) return undefined;
    const intersect = turf.lineIntersect(seg1, seg2);
    if (intersect.features.length === 0) return undefined;
    const coords = intersect.features[0].geometry.coordinates;
    const spatial = this.spatialContext!.SpatialCoord({ lng: coords[0], lat: coords[1] });
    const coord = this.spatialContext!.PixoSpatialCoord(spatial);
    return coord;

  }
  GetExtent(): [number, number, number, number] {
    const bbox = [180, 90, -180, -90];
    this.points.every(({ coord }) => {
      bbox[0] = Math.min(bbox[0], coord.spatial.lng);
      bbox[1] = Math.min(bbox[1], coord.spatial.lat);
      bbox[2] = Math.max(bbox[2], coord.spatial.lng);
      bbox[3] = Math.max(bbox[3], coord.spatial.lat);
      return true;
    });
    return bbox as [number, number, number, number];
  }
  HasVertex(coord: PixoSpatialCoord): any | false {
    for (const vertex of this.points) {
      const vCoord = (vertex.coord as PixoSpatialCoord).spatial;
      const sameLng = vCoord.lng === coord.spatial.lng; //vCoord.lng.toPrecision(6) === coord.spatial.lng.toPrecision(6);
      const sameLat = vCoord.lat === coord.spatial.lat;//vCoord.lat.toPrecision(6) === coord.spatial.lat.toPrecision(6);
      if (sameLng && sameLat) return vertex;
    }
    return false;
  }
  protected FeatureRemoved(feature: any) {
    return; //override me
  }

}
